<template>
  <div>
    <div>
      <client-info :id="order['client']['id']" />
    </div>
    <br />
    <p class="text-danger" v-if="info">{{ info }}</p>
    <br />
    <div class="install-control">
      <button @click="next" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import ClientInfo from "@/components/Partners/ClientInfo";
import { logger } from "../../../plugins/functions";

export default {
  components: {
    ClientInfo,
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    index: {
      default: 0,
    },
    buyer: {
      default: null,
    },
  },
  name: "filter",
  async created() {},
  methods: {
    next() {
      this.save();
    },
    prev() {
      this.$emit("next", this.index - 1);
    },
    async createFile(client = null, name = "passport_1") {
      try {
        let response = await fetch(client[name]);
        let data = await response.blob();
        let metadata = {
          type: "image/jpeg",
        };
        const file = new File([data], `${client["id"]}_${name}.jpg`, metadata);
        //  console.log(file);
        return file;
      } catch (error) {}
      return "";
    },
    async save() {
      this.$loading(true);
      let bodyFormData = new FormData();
      bodyFormData.append("step", 2);
      bodyFormData.append(
        "passport_type",
        this.order.client.passport_prefix === "id" ? 0 : 6
      );
      bodyFormData.append("buyer_id", this.buyer);

      if (this.order.client.passport_prefix == "id") {
        bodyFormData.append(
          "id_first_page",
          await this.createFile(this.order.client, "passport_1")
        );
        bodyFormData.append(
          "id_second_page",
          await this.createFile(this.order.client, "passport_3")
        );
        bodyFormData.append(
          "id_with_address",
          await this.createFile(this.order.client, "passport_2")
        );
        bodyFormData.append(
          "id_selfie",
          await this.createFile(this.order.client, "passport_4")
        );
      } else {
        bodyFormData.append(
          "passport_selfie",
          await this.createFile(this.order.client, "passport_4")
        );
        bodyFormData.append(
          "passport_first_page",
          await this.createFile(this.order.client, "passport_1")
        );
        bodyFormData.append(
          "passport_with_address",
          await this.createFile(this.order.client, "passport_2")
        );
      }

      logger(this.$http, {
        name: "Добавление паспорта в #PAYMART",
        description: "Начало запроса",
        model_type: "order",
        model_id: this.order.id,
      });

      this.$http({
        url: `${this.partner["endpoint_url"]}partner/buyers/modify`,
        // method: 'method',
        method: "POST",
        data: bodyFormData,
        headers: {
          Authorization: `Bearer ${this.partner["api_secret_key"]}`,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          if (response.data) {
            switch (response.data.status) {
              case "success":
                this.message = "Данные успешно загруженны";
                setTimeout(() => {
                  this.$emit("next", 7);
                }, 10);
                break;
              default:
                this.message = "Ошибка системы PAYMART";
                this.info = response.data;
                break;
            }
            logger(this.$http, {
              name: "Добавление паспорта в #PAYMART",
              description: this.message,
              model_type: "order",
              model_id: this.order.id,
            });

            this.$notify({
              title: "PAYMART",
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
          }
        })
        .catch((error) => {
          logger(this.$http, {
            name: "Добавление паспорта в #PAYMART",
            description: "Ошибка системы #PAYMART",
            model_type: "order",
            model_id: this.order.id,
          });

          alert("Ошибка загрузки");
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      message: "",
      info: null,
    };
  },
};
</script>

